import { AfterViewInit, Directive, ElementRef, EventEmitter, OnDestroy, Output } from '@angular/core';

const linkSelector = `a[href]:not([disabled]), button:not([disabled])`;

@Directive({
  selector: '[shrdPfFtSelectableLinks]',
  exportAs: 'shrdPfFtSelectableLinks'
})
export class SelectableLinksDirective implements AfterViewInit, OnDestroy {
  private mutationObserver: MutationObserver = null;

  @Output() selectableLinksUpdated = new EventEmitter<NodeListOf<HTMLElement>>();

  constructor(private readonly elementRef: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    this.updateLinkElements();
    this.observeLinkElementsChange();
  }

  ngOnDestroy(): void {
    this.unobserveLinkElementsChange();
  }

  private updateLinkElements(): void {
    const linkElements: NodeListOf<HTMLElement> = this.elementRef.nativeElement.querySelectorAll(linkSelector);
    this.selectableLinksUpdated.emit(linkElements);
  }

  private observeLinkElementsChange(): void {
    this.mutationObserver = new MutationObserver(records => {
      for (const { addedNodes, removedNodes, attributeName } of records) {
        // update if link elements added / removed
        const shouldUpdateLinkElements = [...Array.from(addedNodes), ...Array.from(removedNodes)].some(
          node => node.nodeType === Node.ELEMENT_NODE && !!(node as Element).querySelector(linkSelector)
        );
        // update if disabled change
        if (attributeName || shouldUpdateLinkElements) {
          this.updateLinkElements();
          break;
        }
      }
    });
    this.mutationObserver.observe(this.elementRef.nativeElement, {
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true
    });
  }

  private unobserveLinkElementsChange(): void {
    this.mutationObserver?.disconnect();
  }
}
